export const XhrDefaultTimeout = 10000;

// desa.tecdata@gmail.com
export const GoogleClientId = '660929707396-m5061gjcj79srajfvti41as2daqogild.apps.googleusercontent.com';
// tecdataarg@gmail.com
// export const GoogleClientId = '914262958430-ipvlveiu5race44qrsvlaap8j1atk6m7.apps.googleusercontent.com';

export const FacebookAppId = '1338645000666778';

// Credencial de prueba de la cuenta gustiger1@gmail.com
export const MercadoPagoPublicKey = 'APP_USR-94f13fa7-a4df-488e-90a1-35e916653cb8';
export const Title = 'PlanetOffice';
export const TitleConector = ' en ';
export const SubTitle = ': Todo para tu oficina. Entrega a domicilio en 24hs.';

export const routes = {
  login: '/login',
  recover: '/recover',
  checkout: '/checkout',
  checkoutCompleted: '/compra-realizada',
  paymentError: '/error-pago',
  checkoutRejected: '/compra-rechazada',
  home: '/',
};

export const ID_NEW = 'new';

// accessValue
export const ACCESS_PRODUCT_TYPE = 'productType';
export const ACCESS_PRODUCT_CATEGORY = 'productCategory';
export const ACCESS_PRODUCT_LANE = 'productLane';
export const ACCESS_PRODUCT_BRAND = 'productBrand';
export const ACCESS_BUSCADOR_INSUMOS = 'BuscadorInsumos';
export const ACCESS_ARTICULO = 'articulo';
export const ACCESS_USERINFO = 'userInfo';
export const LOGIN_REQUIRED = 'login_required';

export const isPathPublicAccess = (origin) => {
  return (
    origin === ACCESS_PRODUCT_TYPE ||
    origin === ACCESS_PRODUCT_CATEGORY ||
    origin === ACCESS_PRODUCT_LANE ||
    origin === ACCESS_ARTICULO ||
    origin === ACCESS_USERINFO
  );
};

// toast
export const ToastPositionDefault = 'bottom-left';
export const ToastTimeDefault = 5000;

// Facturacion
export const IVA1 = '21%';
export const IVA2 = '10,5%';
export const CHEQUE_TEXT = 'Cheque';

// Direcciones
export const LocalShipping = 'Transporte Planet Office'; //'Transporte propio';
export const TransportistaShipping = 'Transportista';
export const ENVIO_PLANET_ZIP = 1900;
export const PROV_SELECTED_DEFAULT_VALUE = 'default';
export const BUENOS_AIRES_ID_VALUE = '001';
export const CAPITAL_FEDERAL_ID_VALUE = '002';
export const BUENOS_AIRES_LABEL = 'Buenos Aires';
export const CAPITAL_FEDERAL_LABEL = 'Capital Federal';

export const MERCADO_PAGO_TIPO = 'Mercado Pago';

// Formato precios

export const SHOW_PRICE_DECIMALS = false;

// Items para scroll

export const LARGO_SCROLL = 10

// Items por pagina de catalogo

export const ITEMS_POR_PAGINA = 18;

// ------------------------------------------------------------------------------------------------------------------------
//                Routes
// ------------------------------------------------------------------------------------------------------------------------

export const articuloRoute = '/articulo';
export const productDetailRoute = '/productDetail'; // mismo que articuloRoute
export const carritoRoute = '/carrito';
export const homeRoute = '/home';
export const loginRoute = '/login';
export const registerRoute = '/register';
export const testRoute = '/test';
export const searchRoute = '/search';
export const checkoutRoute = '/checkout';
export const wishlistRoute = '/wishlist';
export const productType = '/productType';
export const productCategory = '/productCategory';
export const profileRoute = '/users';
export const addressesRoute = '/addresses';
export const ordersRoute = '/orders';
export const enviosRoute = '/envios';
export const activeUserRoute = '/activateUser';
export const notificacionesListRoute = '/NotificacionesList';
export const seguimientoPedidoRoute = '/SeguimientoPedido';
export const registerPendingConfirmationRoute = '/registerPendingConfirmation';
export const recoverRoute = '/recover';
export const recoverUserRoute = '/recoverUser';
export const userInfoRoute = '/userInfo';
export const buscadorInsumosRoute = '/buscadorInsumos';
export const serviciosClienteRoute = '/serviciosAlCliente';

export const resmas_multifuncionRoute = `${productType}/resmas-multifuncion`;
export const Resmas_colorRoute = `${productType}/Resmas-color`;
export const Papeles_especialesRoute = `${productType}/Papeles-especiales`;
export const Formulario_continuoRoute = `${productType}/Formulario-continuo`;
export const CuadernosRoute = `${productType}/Cuadernos`;
export const BlocksRoute = `${productType}/Blocks`;
export const CuadernillosRoute = `${productType}/Cuadernillos`;
export const Repuesto_cuadernosRoute = `${productType}/Repuesto-cuadernos`;
export const Block_para_rotafolioRoute = `${productType}/Block_para-rotafolio`;
export const Sobres_manilaRoute = `${productType}/Sobres-manila`;
export const Sobres_papel_obraRoute = `${productType}/Sobres-papel-obra`;
export const Sobres_plasticosRoute = `${productType}/Sobres-plasticos`;
export const FormulariosRoute = `${productType}/Formularios`;
export const Libros_comercialesRoute = `${productType}/Libros-comerciales`;
export const Rollos_Maq_SumarRoute = `${productType}/Rollos-Maq-Sumar`;
export const Rollos_faxRoute = `${productType}/Rollos-fax`;
export const Rollos_papel_filmRoute = `${productType}/Rollos-papel-film`;
export const Rollos_ContactRoute = `${productType}/Rollos-Contact`;
export const Rollos_de_PVCRoute = `${productType}/Rollos-de-PVC`;
export const Rollos_para_plottersRoute = `${productType}/Rollos-para-plotters`;
export const Papel_CarbonicoRoute = `${productType}/Papel-Carbonico`;
export const Papel_maderaRoute = `${productType}/Papel-madera`;
export const Papel_misioneroRoute = `${productType}/Papel-misionero`;
export const CartulinaRoute = `${productType}/Cartulina`;
export const Papel_comercioRoute = `${productType}/Papel-comercio`;
export const Papel_de_forrarRoute = `${productType}/Papel-de-forrar`;
export const Papel_de_CalcarRoute = `${productType}/Papel-de-Calcar`;
export const Papel_para_dibujoRoute = `${productType}/Papel-para-dibujo`;
export const EtiquetasRoute = `${productType}/Etiquetas`;
export const Tacos_de_papelRoute = `${productType}/Tacos-de-papel`;
export const Tacos_calendariosRoute = `${productType}/Tacos-calendarios`;
export const TalonarioRoute = `${productType}/Talonario`;
export const OjalillosRoute = `${productType}/Ojalillos`;
export const Hojas_para_plastificarRoute = `${productType}/Hojas-para-plastificar`;
export const TransparenciasRoute = `${productType}/Transparencias`;
export const BoligrafosRoute = `${productType}/Boligrafos`;
export const RollersRoute = `${productType}/Rollers`;
export const LapiceraRoute = `${productType}/Lapicera`;
export const CorrectoresRoute = `${productType}/Correctores`;
export const LapicesRoute = `${productType}/Lapices`;
export const PortaminasRoute = `${productType}/Portaminas`;
export const MinasRoute = `${productType}/Minas`;
export const Lapices_de_colorRoute = `${productType}/Lapices-de-color`;
export const SacapuntasRoute = `${productType}/Sacapuntas`;
export const GomasRoute = `${productType}/Gomas`;
export const ResaltadoresRoute = `${productType}/Resaltadores`;
export const MarcadoresRoute = `${productType}/Marcadores`;
export const Tanque_para_Roller_ballRoute = `${productType}/Tanque-para-Roller-ball`;
export const Tanque_para_boligrafoRoute = `${productType}/Tanque-para-boligrafo`;
export const Cartucho_para_lapiceraRoute = `${productType}/Cartucho-para-lapicera`;
export const Tinta_para_marcadoresRoute = `${productType}/Tinta-para-marcadores`;
export const Set_de_escrituraRoute = `${productType}/Set-de-escritura`;
export const TizasRoute = `${productType}/Tizas`;
export const Cinta_Para_Matriz_de_puntoRoute = `${productType}/Cinta-Para-Matriz-de-punto`;
export const CDsRoute = `${productType}/CDs`;
export const DVDRoute = `${productType}/DVD`;
export const MochilasRoute = `${productType}/Mochilas`;
export const MemoriasRoute = `${productType}/Memorias`;
export const Cinta_back_upRoute = `${productType}/Cinta-back-up`;
export const Porta_CDsRoute = `${productType}/Porta-CDs`;
export const Porta_DVDsRoute = `${productType}/Porta-DVDs`;
export const Porta_diskettesRoute = `${productType}/Porta-diskettes`;
export const MouseRoute = `${productType}/Mouse`;
export const MonitoresRoute = `${productType}/Monitores`;
export const NotebooksRoute = `${productType}/Notebooks`;
export const TecladosRoute = `${productType}/Teclados`;
export const Web_CamRoute = `${productType}/Web-Cam`;
export const AuricularesRoute = `${productType}/Auriculares`;
export const ParlantesRoute = `${productType}/Parlantes`;
export const Pad_mouseRoute = `${productType}/Pad-mouse`;
export const Power_BankRoute = `${productType}/Power-Bank`;
export const CablesRoute = `${productType}/Cables`;
export const Filtros_monitorRoute = `${productType}/Filtros-monitor`;
export const FundasRoute = `${productType}/Fundas`;
export const Aire_ComprimidoRoute = `${productType}/Aire-Comprimido`;
export const Copy_holderRoute = `${productType}/Copy-holder`;
export const Brazos_Porta_MonitorRoute = `${productType}/Brazos-Porta-Monitor`;
export const HerramientasRoute = `${productType}/Herramientas`;
export const AbrochadorasRoute = `${productType}/Abrochadoras`;
export const PerforadorasRoute = `${productType}/Perforadoras`;
export const SacabrochesRoute = `${productType}/Sacabroches`;
export const Repuesto_perforadorasRoute = `${productType}/Repuesto-perforadoras`;
export const Broches_para_abrochadorasRoute = `${productType}/Broches-para-abrochadoras`;
export const ClipsRoute = `${productType}/Clips`;
export const Aprieta_papelRoute = `${productType}/Aprieta-papel`;
export const Broches_dos_puntasRoute = `${productType}/Broches-dos-puntas`;
export const Broches_NepacoRoute = `${productType}/Broches-Nepaco`;
export const Broches_NixsoRoute = `${productType}/Broches-Nixso`;
export const ArosRoute = `${productType}/Aros`;
export const ArandelasRoute = `${productType}/Arandelas`;
export const ChinchesRoute = `${productType}/Chinches`;
export const AlfileresRoute = `${productType}/Alfileres`;
export const SeñaladoresRoute = `${productType}/Señaladores`;
export const AdhesivosRoute = `${productType}/Adhesivos`;
export const Cintas_adhesivasRoute = `${productType}/Cintas-adhesivas`;
export const CestoRoute = `${productType}/Cesto`;
export const TijerasRoute = `${productType}/Tijeras`;
export const AlmohadillasRoute = `${productType}/Almohadillas`;
export const SellosRoute = `${productType}/Sellos`;
export const Tinta_para_sellosRoute = `${productType}/Tinta-para-sellos`;
export const ReglasRoute = `${productType}/Reglas`;
export const MojadedosRoute = `${productType}/Mojadedos`;
export const Pincha_papelesRoute = `${productType}/Pincha-papeles`;
export const Organizadores_de_EscritorioRoute = `${productType}/Organizadores-de-Escritorio`;
export const Bandeja_porta_papelesRoute = `${productType}/Bandeja-porta-papeles`;
export const Porta_lapizRoute = `${productType}/Porta-lapiz`;
export const Porta_clipsRoute = `${productType}/Porta-clips`;
export const Porta_tacoRoute = `${productType}/Porta-taco`;
export const Porta_taco_calendarioRoute = `${productType}/Porta-taco-calendario`;
export const Porta_rolloRoute = `${productType}/Porta-rollo`;
export const PortasellosRoute = `${productType}/Portasellos`;
export const PosasobresRoute = `${productType}/Posasobres`;
export const AbrecartasRoute = `${productType}/Abrecartas`;
export const Cintas_maquinas_escribirRoute = `${productType}/Cintas-maquinas-escribir`;
export const AgendasRoute = `${productType}/Agendas`;
export const Repuesto_agendaRoute = `${productType}/Repuesto-agenda`;
export const PilasRoute = `${productType}/Pilas`;
export const RevisteroRoute = `${productType}/Revistero`;
export const CofresRoute = `${productType}/Cofres`;
export const Porta_credencialRoute = `${productType}/Porta-credencial`;
export const Tubo_Porta_PlanoRoute = `${productType}/Tubo-Porta-Plano`;
export const Detector_de_BilletesRoute = `${productType}/Detector-de-Billetes`;
export const LupasRoute = `${productType}/Lupas`;
export const Cintas_embalajeRoute = `${productType}/Cintas-embalaje`;
export const Bandas_elasticasRoute = `${productType}/Bandas-elasticas`;
export const CortantesRoute = `${productType}/Cortantes`;
export const Repuesto_cortanteRoute = `${productType}/Repuesto-cortante`;
export const HilosRoute = `${productType}/Hilos`;
export const BolsasRoute = `${productType}/Bolsas`;
export const SeparadoresRoute = `${productType}/Separadores`;
export const FoliosRoute = `${productType}/Folios`;
export const EspiralesRoute = `${productType}/Espirales`;
export const Tapas_anilladoRoute = `${productType}/Tapas-anillado`;
export const Porta_blocksRoute = `${productType}/Porta-blocks`;
export const Indice_telefonicoRoute = `${productType}/Indice-telefonico`;
export const TarjeterosRoute = `${productType}/Tarjeteros`;
export const Repuesto_tarjeteroRoute = `${productType}/Repuesto-tarjetero`;
export const FichasRoute = `${productType}/Fichas`;
export const Cajas_ArchivoRoute = `${productType}/Cajas-Archivo`;
export const Cajas_Fibra_NegraRoute = `${productType}/Cajas-Fibra-Negra`;
export const CarpeterosRoute = `${productType}/Carpeteros`;
export const FicherosRoute = `${productType}/Ficheros`;
export const ClasificadoresRoute = `${productType}/Clasificadores`;
export const Carpetas_de_presentacionRoute = `${productType}/Carpetas-de-presentacion`;
export const Carpetas_base_opacaRoute = `${productType}/Carpetas-base-opaca`;
export const Carpeta_con_bolsillosRoute = `${productType}/Carpeta-con-bolsillos`;
export const Carpetas_en_LRoute = `${productType}/Carpetas-en-L`;
export const Carpetas_plasticas_sin_anillosRoute = `${productType}/Carpetas-plasticas-sin-anillos`;
export const Carpetas_con_vainaRoute = `${productType}/Carpetas-con-vaina`;
export const Carpetas_con_clip_deslizableRoute = `${productType}/Carpetas-con-clip-deslizable`;
export const BiblioratosRoute = `${productType}/Biblioratos`;
export const Lomo_para_biblioratosRoute = `${productType}/Lomo-para-biblioratos`;
export const Carpetas_internasRoute = `${productType}/Carpetas-internas`;
export const Carpetas_colgantesRoute = `${productType}/Carpetas-colgantes`;
export const Carpetas_de_cartulinaRoute = `${productType}/Carpetas-de-cartulina`;
export const Carpetas_con_folioRoute = `${productType}/Carpetas-con-folio`;
export const Carpetas_con_elasticosRoute = `${productType}/Carpetas-con-elasticos`;
export const Carpetas_con_anillosRoute = `${productType}/Carpetas-con-anillos`;
export const Carpetas_broche_VeloxRoute = `${productType}/Carpetas-broche-Velox`;
export const Carpetas_broche_KismetRoute = `${productType}/Carpetas-broche-Kismet`;
export const CalculadorasRoute = `${productType}/Calculadoras`;
export const Rodillo_entintadorRoute = `${productType}/Rodillo-entintador`;
export const RotuladoraRoute = `${productType}/Rotuladora`;
export const Cinta_rotuladoraRoute = `${productType}/Cinta-rotuladora`;
export const MultifuncionRoute = `${productType}/Multifuncion`;
export const Equipo_de_faxRoute = `${productType}/Equipo-de-fax`;
export const Film_para_faxRoute = `${productType}/Film-para-fax`;
export const Destructora_de_documentosRoute = `${productType}/Destructora-de-documentos`;
export const GuillotinasRoute = `${productType}/Guillotinas`;
export const CafeRoute = `${productType}/Cafe`;
export const MateRoute = `${productType}/Mate`;
export const TeRoute = `${productType}/Te`;
export const Filtro_para_cafeRoute = `${productType}/Filtro-para-cafe`;
export const Leche_en_polvoRoute = `${productType}/Leche-en-polvo`;
export const AzucarRoute = `${productType}/Azucar`;
export const EdulcoranteRoute = `${productType}/Edulcorante`;
export const ServilletasRoute = `${productType}/Servilletas`;
export const RevolvedoresRoute = `${productType}/Revolvedores`;
export const Rollos_cocinaRoute = `${productType}/Rollos-cocina`;
export const VasosRoute = `${productType}/Vasos`;
export const GalletitasRoute = `${productType}/Galletitas`;
export const Pizarra_magneticaRoute = `${productType}/Pizarra-magnetica`;
export const Pizarra_blancaRoute = `${productType}/Pizarra-blanca`;
export const Pizarra_de_corchoRoute = `${productType}/Pizarra-de-corcho`;
export const Pizarra_combinadaRoute = `${productType}/Pizarra-combinada`;
export const RotafoliosRoute = `${productType}/Rotafolios`;
export const PizarronRoute = `${productType}/Pizarron`;
export const RetroproyectorRoute = `${productType}/Retroproyector`;
export const Pantalla_para_proyeccionRoute = `${productType}/Pantalla-para-proyeccion`;
export const ProyectorRoute = `${productType}/Proyector`;
export const Puntero_laserRoute = `${productType}/Puntero-laser`;
export const ImanesRoute = `${productType}/Imanes`;
export const BorradorRoute = `${productType}/Borrador`;
export const Destructora_documentosRoute = `${productType}/Destructora-documentos`;

export const ResmasRoute = `${productCategory}/00000001`;
export const RollosRoute = `${productCategory}/00000002`;
export const SobresRoute = `${productCategory}/00000003`;
export const PapelesEspecificosRoute = `${productCategory}/00000004`;
export const CuadernosBlocksRoute = `${productCategory}/00000005`;
export const PapeleriaOtrosRoute = `${productCategory}/00000006`;
export const EscrituraTintaRoute = `${productCategory}/00000007`;
export const EscrituraLapizRoute = `${productCategory}/00000008`;
export const EscrituraMarcadorRoute = `${productCategory}/00000009`;
export const BorradoRoute = `${productCategory}/00000010`;
export const EscrituraRepuestosRoute = `${productCategory}/00000011`;
export const EscrituraOtrosRoute = `${productCategory}/00000012`;

export const AlmacenamientoRoute = `${productCategory}/00000014`;
export const InformaticaPortaRoute = `${productCategory}/00000015`;
export const PerifericosRoute = `${productCategory}/00000016`;
export const InformaticaOtrosRoute = `${productCategory}/00000017`;
export const AbrochadorasPerforadorasRoute = `${productCategory}/00000018`;
export const BrochesClipsOtrosRoute = `${productCategory}/00000019`;
export const BasicosOficinasRoute = `${productCategory}/00000020`;
export const ElementosEscritorioRoute = `${productCategory}/00000021`;
export const BasicosAccesoriosRoute = `${productCategory}/00000022`;
export const EmpaqueRoute = `${productCategory}/00000023`;
export const ArchivoRoute = `${productCategory}/00000024`;
export const CarpetaPresentacionRoute = `${productCategory}/00000025`;
export const CarpetasVariasRoute = `${productCategory}/00000026`;
export const AccesoriosCarpetasRoute = `${productCategory}/00000027`;
export const ArchivoOtrosRoute = `${productCategory}/00000028`;
export const PizarrasRoute = `${productCategory}/00000029`;
export const ComunicacionVisualRoute = `${productCategory}/00000030`;
export const PresentacionAccesoriosRoute = `${productCategory}/00000031`;
export const CalculadorasAccesoriosRoute = `${productCategory}/00000032`;
export const RotuladorasAccesoriosRoute = `${productCategory}/00000033`;
export const MultifuncionFaxRoute = `${productCategory}/00000034`;
export const DesrtructoraGuillotinasRoute = `${productCategory}/00000035`;
export const CafeMateTeRoute = `${productCategory}/00000036`;
export const LecheEndulzantesRoute = `${productCategory}/00000037`;
export const CafeteriaAccesoriosRoute = `${productCategory}/00000038`;
export const CafeteriaGalletitasRoute = `${productCategory}/00000042`;
